import { useAuth } from '../contexts/AuthContext';

export default function AuthenticatedRedirect({ authenticated, unauthenticated }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-quiltt-purple border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return user ? authenticated : unauthenticated;
}
